export default __webpack_public_path__ + "static/media/egoldcrossbow.6cbcd284.PNG";